"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CardExtraContent = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _Link = _interopRequireDefault(require("@material-ui/icons/Link"));
var _styles = require("./styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CardExtraContent = _ref => {
  let {
    title,
    image,
    hoverTitle,
    copyIcon,
    onClick,
    icon,
    color
  } = _ref;
  const classes = (0, _styles.useStyles)();
  const colorMapping = {
    light: classes.colorLight,
    main: classes.colorMain
  };
  return /*#__PURE__*/_react.default.createElement(_core.Card, {
    elevation: 0,
    className: classes.root,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_core.CardContent, null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.hover
  }, /*#__PURE__*/_react.default.createElement("h6", {
    className: classes.hoverLink
  }, hoverTitle)), icon && /*#__PURE__*/_react.default.createElement("div", {
    className: `${classes.iconDiv} ${colorMapping[color]}`
  }, icon), image && /*#__PURE__*/_react.default.createElement(_core.CardMedia, {
    component: "img",
    alt: "External link cover",
    image: image
  })), /*#__PURE__*/_react.default.createElement(_core.CardActions, null, /*#__PURE__*/_react.default.createElement("p", {
    className: classes.title
  }, title, " ", copyIcon && /*#__PURE__*/_react.default.createElement(_Link.default, {
    className: classes.icon
  }))));
};
exports.CardExtraContent = CardExtraContent;
CardExtraContent.propTypes = {
  /**
   * Se 'True', o ícone de link é exibido
   */
  copyIcon: _propTypes.default.bool,
  /**
   * Texto a ser exibido na parte de baixo
   */
  title: _propTypes.default.string.isRequired,
  /**
   * Texto a ser exibido no hover do componente
   */
  hoverTitle: _propTypes.default.string.isRequired,
  /**
   * Fonte da imagem
   */
  image: _propTypes.default.string,
  /**
   * Icone de fundo
   */
  icon: _propTypes.default.node,
  /**
   * Funçao a ser executada ao clicar no componente
   */
  onClick: _propTypes.default.func,
  /**
   * Cor do tema
   */
  color: _propTypes.default.oneOf(['main', 'light'])
};
CardExtraContent.defaultProps = {
  copyIcon: true,
  onClick: () => {},
  image: null,
  icon: null,
  color: 'main'
};
var _default = exports.default = CardExtraContent;